<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col sm:flex-row gap-2">
            <div class="relative">
                <input type="text" [(ngModel)]="search" (ngModelChange)="onSearch($event)" placeholder="Search.."
                    class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <!-- <div class="min-w-48">
                <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                    (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
            </div> -->

        </div>
        <div *ngIf="payments && payments.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (payments.length !=
                numberOfRecords? (numberOfRecords
                -payments.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div></div>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                       Actions
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        User
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Card Holder Name
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Card
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Card Type
                                    </th>
                                   
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Exp Month
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Exp Year
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Billing Address
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Card Id
                                    </th>
                                    <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Created At
                                </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of payments | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <ng-container *ngIf="!item.isDefault">
                                    <span (click)="deletePayment(item.id)"
                                        class=" text-red-500 dark:text-red-400 hover:text-red-600 dark:hover:text-red-700 group flex items-center px-4 py-1 text-sm ng-star-inserted"><svg
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            class="cursor-pointer mr-3 h-5 w-5 text-main-primary">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0">
                                            </path>
                                        </svg>
                                    </span>
                                    </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="item.member" >
                                            {{item.member.displayName | titlecase}}
                                       </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.cardholderName || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span >
                                                <span class="text-zinc-600 dark:text-white">{{ item.cardBrand |
                                                    titlecase }}</span>
                                                <span> ({{ (item.last4 | titlecase) || '' }})</span>
                                            </span>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.cardType || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.expMonth || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.expYear || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.billingAddress?.country || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.squareCardId || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(item.createdAt |date:'MM/DD/YYYY') || ''}}
                                    </td>
                                    <td class="space-x-2 px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="item.isDefault" class="badge-primary">
                                            Default
                                        </span>
                                        <span [ngClass]="item.isActive ? 'badge-success' : 'badge-danger'" class="">
                                            {{item.isActive ? 'Active' : 'Inactive'}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>